<div class="flex flex-col max-w-90 min-w-90 max-h-screen -m-6">
  <!-- Header -->
  <div
    class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary"
  >
    <div class="text-lg font-medium">Transfer Account Ownership</div>
    <button mat-icon-button (click)="cancel()" [tabIndex]="-1">
      <mat-icon
        class="text-current"
        [svgIcon]="'heroicons_outline:x'"
      ></mat-icon>
    </button>
  </div>

  <div class="flex flex-col flex-auto p-8 overflow-y-auto">
    <p class="mb-2">
      Make <strong>{{ data.target_user_name }}</strong>
      (<span class="text-secondary">{{ data.target_user_email }}</span
      >) the owner of the selected account(s).
    </p>
    <p class="text-secondary mb-6">
      The current owner of each account will be demoted to an admin role.
    </p>

    <!-- Loading accounts -->
    <div
      *ngIf="isLoadingAccounts"
      class="flex items-center justify-center py-4"
    >
      <mat-spinner [diameter]="32"></mat-spinner>
    </div>

    <ng-container *ngIf="!isLoadingAccounts">
      <!-- Account selection -->
      <div *ngIf="hasMultipleAccounts" class="mb-4">
        <div class="text-md font-medium mb-2">Select accounts:</div>
        <div *ngFor="let entry of eligibleAccounts" class="mb-1">
          <mat-checkbox [(ngModel)]="entry.selected">
            {{ entry.account_name }}
            <span class="text-secondary text-sm ml-1"
              >({{ entry.role | snakeCaseSplit | titlecase }})</span
            >
          </mat-checkbox>
        </div>
      </div>

      <!-- Single account display -->
      <div *ngIf="!hasMultipleAccounts && eligibleAccounts.length === 1">
        <p class="mb-4">
          Account: <strong>{{ eligibleAccounts[0].account_name }}</strong>
        </p>
      </div>

      <!-- No eligible accounts -->
      <div *ngIf="eligibleAccounts.length === 0">
        <p class="text-warn mb-4">
          This user is already the owner of all their associated accounts.
        </p>
      </div>
    </ng-container>

    <mat-checkbox
      *ngIf="eligibleAccounts.length > 0"
      [(ngModel)]="confirmed"
    >
      I confirm this ownership transfer
    </mat-checkbox>

    <div *ngIf="errorMessage" class="text-warn mt-4">{{ errorMessage }}</div>

    <div class="flex flex-row-reverse mt-6">
      <button
        *ngIf="eligibleAccounts.length > 0"
        class="ml-4"
        mat-flat-button
        [color]="'warn'"
        (click)="submit()"
        [disabled]="!confirmed || isLoading || selectedAccountIds.length === 0"
      >
        <mat-spinner
          *ngIf="isLoading"
          class="mr-2"
          [diameter]="20"
        ></mat-spinner>
        Update Owner
      </button>
      <button mat-button (click)="cancel()">Cancel</button>
    </div>
  </div>
</div>
